import { render } from "./Divider.vue?vue&type=template&id=f8bd60e8&scoped=true"
import script from "./Divider.vue?vue&type=script&lang=js"
export * from "./Divider.vue?vue&type=script&lang=js"

import "./Divider.vue?vue&type=style&index=0&id=f8bd60e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bd60e8"]])

export default __exports__